import React from 'react';

import './styles/breadcrumbs.scss';

const Breadcrumbs = (props) => {
  const items = [
    {
      name: 'Регистрация',
      index: 1,
    },
    {
      name: 'Проверка',
      index: 2,
    },
    {
      name: 'Оплата',
      index: 3,
    },
  ];

  const { currentItem, goBackHandle } = props;

  return (
      <section className="breadcrumbs">
        <span className="breadcrumbs__back-button">
            <button type="button" onClick={goBackHandle}>Назад</button>
        </span>
        <div className="breadcrumbs__items">
            {
                items.map(item => {
                    return (
                        <div className={`breadcrumbs__items__item-progress-block ${currentItem === item.index ? "_active" : (currentItem > item.index ? "_passed" : "")}`} key={item.index}>
                            <div className={`breadcrumbs__items__item`}>
                                <div className={`breadcrumbs__items__item-index`}>{item.index}</div>
                                <div className={`breadcrumbs__items__item-name`}>{item.name}</div>
                            </div>
                        </div>
                    );
                })
            }
        </div>
      </section>
  );
};

export default Breadcrumbs;
